<template>
  <div class="word-entry-container">
    <div class="grid grid-cols-1 row-gap-2 content">
      <div class="input-container">
        <input
          class="word-input md:md-word-input"
          ref="input"
          v-model="nextWord"
          v-on:keyup.enter="addWord"
          v-bind:disabled="inputDisabled"
          autocomplete="off"
          spellcheck="false"
        />
      </div>
      <div class="words-container md:md-words-container">
        <p>{{ allWordsListed() }}</p>
      </div>
      <div class="timer-container md:md-timer-container">
        <div class="timer md:md-timer">{{ remainingTime }}s</div>
        <div class="arc md:md-arc"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WordEntry',
  data() {
    return {
      nextWord: '',
      inputDisabled: false,
      entryDuration: 60,
      remainingTime: null,
      endTime: null,
      interval: null,
    };
  },
  methods: {
    addWord() {
      if (this.nextWord) {
        this.$store.commit('addWord', this.nextWord);
        this.nextWord = '';
      }
    },
    allWordsListed() {
      let list = '';

      for (let i = 0; i < this.$store.state.words.length; i += 1) {
        list += this.$store.state.words[i];

        if (i < this.$store.state.words.length - 1) {
          list += ', ';
        } else {
          list += '...';
        }
      }

      return list;
    },
    updateTimer() {
      // this.remainingTime = Math.round((this.endTime - Date.now()) / 1000);
      this.remainingTime -= 1;

      if (this.remainingTime <= 0) {
        this.inputDisabled = true;
        clearInterval(this.interval);

        if (!this.$store.state.words.length) {
          this.$store.commit('reset');

          return;
        }

        this.$store.commit('setView', 'WordSubmit');
      }
    },
  },
  mounted() {
    this.$refs.input.focus();
    this.endTime = Date.now() + this.entryDuration * 1000;
    this.remainingTime = this.entryDuration;
    this.interval = setInterval(() => {
      this.updateTimer();
    }, 1000);
  },
};
</script>

<style scoped>
.arc {
  animation: rotate 2s infinite linear;
  border: 1px solid #5e5b5c;
  border-radius: 50%;
  border-top-color: transparent;
  height: 50px;
  left: calc(50vw - 25px);
  margin: auto;
  position: absolute;
  top: 0;
  width: 50px;
}

.content {
  align-self: center;
  width: 100%
}

.timer {
  padding-top: 12.5px;
}

.timer-container {
  position: relative;
}

.word-entry-container {
  align-content: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  margin: auto;
  width: 100vw;
}

.word-input {
  border-color: #5e5b5c;
  border-radius: 5rem;
  border-style: solid;
  border-width: 1px;
  font-size: 2rem;
  font-weight: bold;
  padding: 0 .5em;
  text-transform: uppercase;
  width: 90%;
}

.word-input:focus {
  outline: none;
}

.words-container {
  font-weight: bold;
  margin-bottom: 2em;
  text-transform: uppercase;
}

@keyframes rotate {
  0%    { transform: rotate(0deg);  }
  100%  { transform: rotate(360deg);  }
}

@responsive {
  .md-arc {
    border-width: 2px;
    height: 100px;
    left: calc(50vw - 50px);
    width: 100px;
  }

  .md-timer {
    padding-top: 25px;
  }

  .md-timer-container {
    font-size: 2.25rem;
  }

  .md-word-input {
    font-size: 3.5rem;
    letter-spacing: .15em;
    width: 37%;
  }

  .md-words-container {
    font-size: 2.25rem;
    letter-spacing: .15em;
  }
}
</style>
